import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PlannedMaintenanceUpdateActions";
import * as api from "../../api/PlannedMaintenanceUpdateApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import moment from "moment";

//download
function* postExportTasksForUpdateDate(action) {
    try {
        const { data } = yield api.postExportTasksForUpdateDate(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_PlannedTasks_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

//upload
function* postUpdateTaskDatesFromExcel(action) {
    try {
        const { data } = yield api.postUpdateTaskDatesFromExcel(action.payload.data);
        yield put(actions.postUpdateTaskDatesFromExcel(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}


function* getExcelListForUpdateDate(action) {
    try {
        console.log(action);
            const { data } = yield api.postDateExcelToList(action.payload.data);
            yield put(actions.setExcelListForUpdateDate(data || undefined));
    
    } catch (error) {
        console.log(error);
        yield put(showErrorSnackbar(error, "error"));
    }
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_EXCEL_FOR_UPDATE_DATE, postExportTasksForUpdateDate);
    yield takeEvery(actions.Types.POST_UPLOAD_FILE_FOR_UPDATE_DATE, postUpdateTaskDatesFromExcel);
    yield takeEvery(actions.Types.GET_EXCEL_LIST_FOR_UPDATE_DATE, getExcelListForUpdateDate);
}

const PlannedMaintenanceUpdateSaga = [fork(watchAll)];

export default PlannedMaintenanceUpdateSaga;
